import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css'

import Vue from 'vue'
import VueRouter from 'vue-router'
import redirect from './components/redirect_alipay.vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import VueSocketIO from 'vue-socket.io'
import VueLodash from 'vue-lodash'
import messages from './resources/languages/lang.js'
import pt_BR from './resources/i18n/messagesPt.js'
import es from './resources/i18n/messagesEs.js'
import en from './resources/i18n/messagesEn.js'
import zh from './resources/i18n/messagesZh.js'
Vue.use(VueI18n)
Vue.use(Vuetify, {
    iconfont: 'md' || 'fa' || 'fa4'
})
Vue.use(new VueSocketIO({
        connection: process.env.VUE_APP_SOCKET
    }))
    // Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages,
})

//translations only for veeValidate plugin, not the whole app
Vue.use(VeeValidate, {
    i18n,
    dictionary: {
        es,
        en,
        pt_BR,
        zh,
    }
});

Vue.use(VueRouter);
const routes = [
    { path: '/redirect/payment', component: redirect },
];
const router = new VueRouter({
    routes,
    mode: 'history'
})

const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional

Vue.config.productionTip = false

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')